import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";
import { siteConfig } from "@/lib/seo/metadata";
import { AdminLink } from "@/shared/design-system/admin/AdminLink";
import { ExternalLink } from "@/shared/ui/external-link";

type ContactSupportLineProps = {
  /** The question before the link: "Need help?", "Still need help?". */
  lead: string;
  analyticsElementId: AnalyticsElementId;
};

/** The closing "Need help? Contact support" line of the app's own status pages, mailing the support address. */
export const ContactSupportLine = ({ lead, analyticsElementId }: ContactSupportLineProps) => (
  <div className="text-sm text-(--color-text-secondary)">
    <p>
      {lead}{" "}
      <AdminLink asChild weight="semibold">
        <ExternalLink analyticsElementId={analyticsElementId} href={`mailto:${siteConfig.contact.support}`}>
          Contact support
        </ExternalLink>
      </AdminLink>
    </p>
  </div>
);
